import { takeLatest, put, call, all } from 'redux-saga/effects';
import LeaveAdjustmentTypes from './LeaveAdjustment.types';
import {
	getEmployeeLeaveBalance,
	createLeaveAdjustment,
	getEmployeeApprovedLeavesForYear,
	updateAppliedLeave,
	getLeaveEditHistory,
} from './LeaveAdjustment.services';
import {
	getEmployeeLeaveBalanceSuccess,
	getEmployeeLeaveBalanceFailure,
	createLeaveAdjustmentSuccess,
	createLeaveAdjustmentFailure,
	getEmployeeApprovedLeavesForYearSuccess,
	getEmployeeApprovedLeavesForYearFailure,
	updateAppliedLeaveSuccess,
	updateAppliedLeaveFailure,
	getLeaveEditHistorySuccess,
	getLeaveEditHistoryFailure,
} from './LeaveAdjustment.actions';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

// ========== GET EMPLOYEE LEAVE BALANCE SAGA START ==========
export function* getEmployeeLeaveBalanceSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getEmployeeLeaveBalance as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getEmployeeLeaveBalanceSuccess(responseData.data));
			} else {
				yield put(getEmployeeLeaveBalanceFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getEmployeeLeaveBalanceFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetEmployeeLeaveBalanceStart(): Generator<any, void, any> {
	yield takeLatest(
		LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_START as any,
		getEmployeeLeaveBalanceSaga,
	);
}
// ========== GET EMPLOYEE LEAVE BALANCE SAGA END ==========

// ========== CREATE LEAVE ADJUSTMENT SAGA START ==========
export function* createLeaveAdjustmentSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(createLeaveAdjustment as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(createLeaveAdjustmentSuccess(responseData.data));
			} else {
				yield put(createLeaveAdjustmentFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			createLeaveAdjustmentFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onCreateLeaveAdjustmentStart(): Generator<any, void, any> {
	yield takeLatest(
		LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_START as any,
		createLeaveAdjustmentSaga,
	);
}
// ========== CREATE LEAVE ADJUSTMENT SAGA END ==========

// ========== GET EMPLOYEE APPROVED LEAVES FOR YEAR SAGA ==========
export function* getEmployeeApprovedLeavesForYearSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			LeaveAdjustmentTypes.GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getEmployeeApprovedLeavesForYear as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		}
		if (responseData.data.status === 'success') {
			yield put(getEmployeeApprovedLeavesForYearSuccess(responseData.data));
		} else {
			yield put(getEmployeeApprovedLeavesForYearFailure(responseData.data));
		}
	} catch (error: any) {
		yield put(
			getEmployeeApprovedLeavesForYearFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetEmployeeApprovedLeavesForYearStart(): Generator<any, void, any> {
	yield takeLatest(
		LeaveAdjustmentTypes.GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_START as any,
		getEmployeeApprovedLeavesForYearSaga,
	);
}

// ========== UPDATE APPLIED LEAVE SAGA ==========
export function* updateAppliedLeaveSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_KEY,
		);
		// @ts-ignore
		const responseData = yield call(updateAppliedLeave as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		}
		if (responseData.data.status === 'success') {
			yield put(updateAppliedLeaveSuccess(responseData.data));
		} else {
			yield put(updateAppliedLeaveFailure(responseData.data));
		}
	} catch (error: any) {
		yield put(
			updateAppliedLeaveFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onUpdateAppliedLeaveStart(): Generator<any, void, any> {
	yield takeLatest(
		LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_START as any,
		updateAppliedLeaveSaga,
	);
}

// ========== GET LEAVE EDIT HISTORY SAGA ==========
export function* getLeaveEditHistorySaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			LeaveAdjustmentTypes.GET_LEAVE_EDIT_HISTORY_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getLeaveEditHistory as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		}
		if (responseData.data.status === 'success') {
			yield put(getLeaveEditHistorySuccess(responseData.data));
		} else {
			yield put(getLeaveEditHistoryFailure(responseData.data));
		}
	} catch (error: any) {
		yield put(
			getLeaveEditHistoryFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetLeaveEditHistoryStart(): Generator<any, void, any> {
	yield takeLatest(
		LeaveAdjustmentTypes.GET_LEAVE_EDIT_HISTORY_START as any,
		getLeaveEditHistorySaga,
	);
}

export function* leaveAdjustmentSagaDetails() {
	yield all([
		call(onGetEmployeeLeaveBalanceStart),
		call(onCreateLeaveAdjustmentStart),
		call(onGetEmployeeApprovedLeavesForYearStart),
		call(onUpdateAppliedLeaveStart),
		call(onGetLeaveEditHistoryStart),
	]);
}

